import { createSlice } from "@reduxjs/toolkit";

const amountSlice = createSlice({
    name:"amount",
    initialState:{
        amountBySymbol:{}
    },
    reducers:{
        setAmountForSymbol(state, action){
            const { symbolId, amount } = action.payload;
            state[symbolId] = amount;
        }
    }
})

export const { setAmountForSymbol } = amountSlice.actions;
export default amountSlice.reducer;